import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ExtractoPasajero } from '../../../shared/model/ExtractoPasajero.model';
import { ExtractoPasajerosService } from '../../../shared/services/extracto-pasajeros.service';

@Component({
  selector: 'app-listado-pasajeros',
  templateUrl: './listado-pasajeros.component.html',
  styleUrls: ['./listado-pasajeros.component.scss']
})
export class ListadoPasajerosComponent implements OnInit {
  isCreating = false;
  extractoId!: number;
  extracto!: any;
  pasajeros: ExtractoPasajero[] = [];
  pasajeroForm!: FormGroup;
  pasajeroEditando?: ExtractoPasajero;
  cargando = false;
  guardando = false;
  modoEdicion = false;
  pasajeroId?: number;
  public TipoDeDocumento = [
    { value: "TI", label: "TARJETA DE IDENTIDAD" },
    { value: "CC", label: "CEDULA DE CIUDADANIA" },
    { value: "CE", label: "CEDULA DE EXTRANJERIA" },
    { value: "PA", label: "PASAPORTE" },
    { value: "PPT", label: "PERMISO POR PROTECCIÓN TEMPORAL " },
    { value: "OTRO", label: "OTRO" },
  ];
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private pasajerosService: ExtractoPasajerosService
  ) { }

  ngOnInit(): void {
    this.crearFormulario();
    this.cargarPasajeros();
  }

  private crearFormulario(): void {
    this.pasajeroForm = this.fb.group({
      tipo_documento: ['CC', Validators.required],
      numero_documento: [
        '',
        [Validators.required, Validators.maxLength(30)]
      ],
      nombresCompleto: [
        '',
        [Validators.required, Validators.maxLength(100)]
      ],

      observacion: ['']
    });
  }

 cargarPasajeros(): void {
  const id = this.obtenerExtractoId();

  if (id === null) {
   /*  Swal.fire(
      'Atención',
      'No se recibió un identificador válido del extracto.',
      'warning'
    ); */
    this.isCreating = true;
    return;
  }

  this.cargando = true;

  this.pasajerosService.listarPasajeros(id).subscribe({
    next: (respuesta: any) => {
      this.pasajeros = Array.isArray(respuesta)
        ? respuesta
        : respuesta?.data ?? respuesta?.pasajeros ?? [];

      this.cargando = false;
    },
    error: (error) => {
      console.error('Error cargando pasajeros:', error);
      this.cargando = false;

      Swal.fire(
        'Error',
        'No fue posible cargar los pasajeros del extracto.',
        'error'
      );
    }
  });
}

  guardarPasajero(): void {

    // si no esta creando un extracto
    if (this.isCreating ==false){
          if (this.pasajeroForm.invalid || this.guardando) {
      this.pasajeroForm.markAllAsTouched();
      return;
    }

    this.guardando = true;

    const pasajero: ExtractoPasajero = {
      ...this.pasajeroForm.getRawValue(),
      extracto_id: this.extracto.idfuec
    };

    const peticion = this.modoEdicion && this.pasajeroId
      ? this.pasajerosService.actualizar(
        this.extracto.idfuec,
        this.pasajeroId,
        pasajero
      )
      : this.pasajerosService.crear(
        pasajero
      );

    peticion.subscribe({
      next: (respuesta: any) => {
        this.guardando = false;

        if (respuesta?.codigo !== undefined && respuesta.codigo !== 0) {
          Swal.fire(
            'Atención',
            respuesta.mensaje || 'No se pudo guardar el pasajero.',
            'warning'
          );
          return;
        }

        Swal.fire({
          icon: 'success',
          title: 'Operación exitosa',
          text: this.modoEdicion
            ? 'Pasajero actualizado correctamente.'
            : 'Pasajero registrado correctamente.',
          timer: 1500,
          showConfirmButton: false
        });

        this.cancelarEdicion();
        this.cargarPasajeros();
      },
      error: (error) => {
        this.guardando = false;
        console.error('Error guardando pasajero:', error);

        Swal.fire(
          'Error',
          error?.error?.mensaje || 'No fue posible guardar el pasajero.',
          'error'
        );
      }
    });
    }else{
        //logica para pasar los datos del pasajero cuando no se está creando un extracto
        console.log('Pasajero a pasar cuando se está creando un extracto:', this.pasajeroForm.getRawValue());
        if(this.modoEdicion){
          //editar pasajero localmente
          this.actualizarPasajero(this.pasajeroForm.getRawValue());
          

        }else{
          this.agregarPasajero(this.pasajeroForm.getRawValue());
        }
        this.pasajeroForm.reset();
    }

  }

 agregarPasajero(pasajero: ExtractoPasajero): void {
  pasajero.estado = 'ACTIVO';
  this.pasajeros.push(pasajero);
  // Notificar el cambio del arreglo a Angular
  this.pasajeros = [...this.pasajeros];
}

actualizarPasajero(pasajeroActualizado: ExtractoPasajero): void {
  const indice = this.pasajeros.findIndex(p =>
    this.isCreating
      ? p === this.pasajeroEditando
      : p.id === pasajeroActualizado.id
  );

  if (indice === -1) {
    console.error('No se encontró el pasajero para actualizar');
    return;
  }

  this.pasajeros[indice] = {
    ...this.pasajeros[indice],
    ...pasajeroActualizado,
    estado: this.pasajeros[indice].estado ?? 'ACTIVO'
  };

  // Notificar el cambio del arreglo a Angular
  this.pasajeros = [...this.pasajeros];
}
editarPasajero(pasajero: ExtractoPasajero): void {

  if (!this.isCreating && !pasajero.id) {
    return;
  }

  this.modoEdicion = true;
  this.pasajeroId = pasajero.id;

  // Guardar el pasajero original para identificarlo en el arreglo local
  this.pasajeroEditando = pasajero;

  this.pasajeroForm.patchValue({
    tipo_documento: pasajero.tipo_documento,
    numero_documento: pasajero.numero_documento,
    nombresCompleto: pasajero.nombresCompleto,
    observacion: pasajero.observacion ?? ''
  });
}

  activarPasajero(pasajero: ExtractoPasajero): void {
    if (!pasajero.id) {
      return;
    }

    Swal.fire({
      title: '¿Activar pasajero?',
      text: `Se activará a ${pasajero.nombresCompleto} en este extracto.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, activar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6'
    }).then((resultado) => {
      if (!resultado.isConfirmed) {
        return;
      }

       pasajero.estado = 'ACTIVO';
    
    this.pasajerosService.actualizar(
      this.extracto.idfuec,
      pasajero.id!,
      pasajero
    )
        .subscribe({
          next: (respuesta: any) => {
            if (
              respuesta?.codigo !== undefined &&
              respuesta.codigo !== 0
            ) {
              Swal.fire(
                'Atención',
                respuesta.mensaje || 'No se pudo activar el pasajero.',
                'warning'
              );
              return;
            }else{
              Swal.fire(
                'Éxito',
                'Pasajero activado correctamente.',
                'success'
              );
            }

            this.cargarPasajeros();
          },
          error: (error) => {
            console.error('Error activando pasajero:', error);

            Swal.fire(
              'Error',
              error?.error?.mensaje || 'No fue posible activar el pasajero.',
              'error'
            );
          }
        });
    });
  }

  //RETIRAR PASAJERO DE LA LISTA
 retirarPasajero(pasajero: ExtractoPasajero): void {

  // Si el extracto ya existe, el pasajero debe tener ID
  if (!this.isCreating && !pasajero.id) {
    return;
  }

  Swal.fire({
    title: '¿Retirar pasajero?',
    text: `Se retirará a ${pasajero.nombresCompleto} de este extracto.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, retirar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#3085d6'
  }).then((resultado) => {

    if (!resultado.isConfirmed) {
      return;
    }

    // CASO 1: Extracto en creación, pasajeros en memoria
    if (this.isCreating) {

      this.pasajeros = this.pasajeros.filter(
        p => p !== pasajero
      );

      if (this.pasajeroId === pasajero.id) {
        this.cancelarEdicion();
      }

      Swal.fire(
        'Éxito',
        'Pasajero retirado de la lista correctamente.',
        'success'
      );

      return;
    }

    // CASO 2: Extracto existente, retirar desde el backends
    this.pasajerosService
      .eliminar(this.extracto.idfuec, pasajero.id!)
      .subscribe({
        next: (respuesta: any) => {

          if (
            respuesta?.codigo !== undefined &&
            respuesta.codigo !== 0
          ) {
            Swal.fire(
              'Atención',
              respuesta.mensaje || 'No se pudo retirar el pasajero.',
              'warning'
            );
            return;
          }

          Swal.fire(
            'Éxito',
            'Pasajero retirado correctamente.',
            'success'
          );

          if (this.pasajeroId === pasajero.id) {
            this.cancelarEdicion();
          }

          this.cargarPasajeros();
        },

        error: (error) => {
          console.error('Error retirando pasajero:', error);

          Swal.fire(
            'Error',
            error?.error?.mensaje ||
              'No fue posible retirar el pasajero.',
            'error'
          );
        }
      });
  });
}

  cancelarEdicion(): void {
    this.modoEdicion = false;
    this.pasajeroId = undefined;

    this.pasajeroForm.reset({
      tipo_documento: 'CC',
      numero_documento: '',
      nombresCompleto: '',
      observacion: ''
    });
  }

cerrar(): void {
  console.log('Pasajeros a enviar:', this.pasajeros);

  this.activeModal.close({
    actualizado: true,
    pasajeros: [...this.pasajeros]
  });
}
  get totalPasajeros(): number {
    return this.pasajeros.length;
  }



generarListado(): void {
 // console.log('Generando listado de pasajeros...');
if (this.isCreating) {
    this.pasajeros = [...this.pasajeros];

    //console.log('Pasajeros guardados en memoria:', this.pasajeros);

     this.cerrar();

    return;
  }
  // Filtrar únicamente pasajeros activos
  const pasajerosActivos = (this.pasajeros || [])
    .filter(pasajero => pasajero.estado === 'ACTIVO');

  if (pasajerosActivos.length === 0) {
    Swal.fire(
      'Sin pasajeros activos',
      'No hay pasajeros activos para generar el listado.',
      'info'
    );
    return;
  }

  // Configuración del documento
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });

  const anchoPagina = pdf.internal.pageSize.getWidth();
  const altoPagina = pdf.internal.pageSize.getHeight();
  const margen = 14;
  const extracto = this.extracto;

  const fechaActual = new Date();
  const fecha = fechaActual.toLocaleDateString('es-CO');
  const hora = fechaActual.toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit'
  });

  // Evitar valores nulos o vacíos
  const dato = (valor: unknown): string => {
    if (
      valor === null ||
      valor === undefined ||
      String(valor).trim() === ''
    ) {
      return 'SIN DATOS';
    }

    return String(valor).trim();
  };

  const origen = extracto?.origen?.trim() || '';
  const destino = extracto?.destino?.trim() || '';

  const ruta = origen || destino
    ? `${origen || 'SIN DATOS'} - ${destino || 'SIN DATOS'}`
    : 'SIN DATOS';

  // ==========================================
  // 1. ENCABEZADO CORPORATIVO
  // ==========================================

  pdf.setFillColor(79, 79, 79);
  pdf.rect(0, 0, anchoPagina, 8, 'F');

  pdf.setTextColor(55, 65, 81);
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(17);

  pdf.text(
    'ADMIN SEAF',
    anchoPagina / 2,
    19,
    { align: 'center' }
  );

  pdf.setFontSize(12);

  pdf.text(
    'LISTADO DE PASAJEROS',
    anchoPagina / 2,
    27,
    { align: 'center' }
  );

  // Línea decorativa roja
  pdf.setDrawColor(61, 61,61);
  pdf.setLineWidth(0.8);

  pdf.line(
    margen,
    32,
    anchoPagina - margen,
    32
  );

  // ==========================================
  // 2. INFORMACIÓN DEL EXTRACTO
  // ==========================================

  pdf.setFillColor(245, 246, 248);

  pdf.roundedRect(
    margen,
    37,
    anchoPagina - margen * 2,
    34,
    2,
    2,
    'F'
  );

  pdf.setTextColor(55, 65, 81);
  pdf.setFontSize(8.5);

  const xEtiquetaIzquierda = margen + 5;
  const xDatoIzquierda = margen + 30;

  const xEtiquetaDerecha = 112;
  const xDatoDerecha = 151;

  // Columna izquierda
  pdf.setFont('helvetica', 'bold');
  pdf.text('PLACA:', xEtiquetaIzquierda, 44);
  pdf.text('CONTRATANTE:', xEtiquetaIzquierda, 52);
  pdf.text('ID FUEC:', xEtiquetaIzquierda, 60);

  pdf.setFont('helvetica', 'normal');
  pdf.text(dato(extracto?.placa), xDatoIzquierda, 44);
  pdf.text(dato(extracto?.nitc), xDatoIzquierda, 52);
  pdf.text(dato(extracto?.idfuec), xDatoIzquierda, 60);

  // Columna derecha
  pdf.setFont('helvetica', 'bold');
  pdf.text('ORIGEN - DESTINO:', xEtiquetaDerecha, 44);
  pdf.text('IMPRESIÓN:', xEtiquetaDerecha, 52);
  pdf.text('TOTAL ACTIVOS:', xEtiquetaDerecha, 60);

  pdf.setFont('helvetica', 'normal');

  // Limitar textos largos para evitar que se superpongan
  const anchoDatoDerecha = anchoPagina - margen - xDatoDerecha;

  pdf.text(
    pdf.splitTextToSize(ruta, anchoDatoDerecha)[0],
    xDatoDerecha,
    44
  );

  pdf.text(
    `${fecha} ${hora}`,
    xDatoDerecha,
    52
  );

  pdf.setFont('helvetica', 'bold');
  pdf.text(
    String(pasajerosActivos.length),
    xDatoDerecha,
    60
  );

  // ==========================================
  // 3. TABLA DE PASAJEROS ACTIVOS
  // ==========================================

  autoTable(pdf, {
    startY: 77,

    head: [[
      'N.º',
      'Tipo documento',
      'Número documento',
      'Nombre completo',
      'Observación',
     
    ]],

    body: pasajerosActivos.map((pasajero, index) => [
      index + 1,
      dato(pasajero.tipo_documento),
      String(pasajero.numero_documento ?? ''),
      dato(pasajero.nombresCompleto),
      pasajero.observacion?.trim() || 'SIN OBSERVACIÓN',
     
    ]),

    theme: 'grid',

    styles: {
      font: 'helvetica',
      fontSize: 8,
      cellPadding: 3,
      overflow: 'linebreak',
      textColor: [55, 65, 81],
      lineColor: [220, 223, 228],
      lineWidth: 0.2,
      valign: 'middle'
    },

    headStyles: {
      fillColor: [79, 79, 79],
      textColor: [255, 255, 255],
      fontStyle: 'bold',
      halign: 'center',
      valign: 'middle',
      cellPadding: 3
    },

    alternateRowStyles: {
      fillColor: [248, 249, 251]
    },

    columnStyles: {
      0: {
        cellWidth: 9,
        halign: 'center'
      },
      1: {
        cellWidth: 25
      },
      2: {
        cellWidth: 29
      },
      3: {
        cellWidth: 42
      },
      4: {
        cellWidth: 'auto'
      },
      5: {
        cellWidth: 19,
        halign: 'center'
      }
    },

    margin: {
      top: 15,
      right: margen,
      bottom: 18,
      left: margen
    },

    // Pie de página en cada página
    didDrawPage: () => {
      pdf.setDrawColor(210, 214, 220);
      pdf.setLineWidth(0.3);

      pdf.line(
        margen,
        altoPagina - 14,
        anchoPagina - margen,
        altoPagina - 14
      );

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(8);
      pdf.setTextColor(100, 100, 100);

      pdf.text(
        'ADMIN SEAF | Listado de pasajeros activos',
        margen,
        altoPagina - 8
      );

      pdf.text(
        `Página ${pdf.getNumberOfPages()}`,
        anchoPagina - margen,
        altoPagina - 8,
        { align: 'right' }
      );
    }
  });

  // ==========================================
  // 4. DESCARGAR PDF
  // ==========================================

  const nombreArchivo =
    `Pasajeros_Extracto_${dato(extracto?.idfuec)}.pdf`;

  pdf.save(nombreArchivo);

  console.log('PDF generado correctamente:', nombreArchivo);
}

private obtenerExtractoId(): number | null {
  const id = this.extracto?.idfuec ?? this.extractoId;

  if (id === null || id === undefined || id === '') {
    return null;
  }

  const idNumerico = Number(id);

  return Number.isFinite(idNumerico) && idNumerico > 0
    ? idNumerico
    : null;
}


}